export default __webpack_public_path__ + "static/media/progress-circle-1.085c9f22.svg";